import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, TextField } from '@mui/material';
/**
 * Custom multi-select filter input component for DataGrid columns.
 * Renders an Autocomplete with multiple selection support.
 */
export const MultiSelectFilterInput = ({ item, applyValue, options }) => {
    const handleChange = (_event, newValue) => {
        applyValue({ ...item, value: newValue });
    };
    return (_jsx(Autocomplete, { multiple: true, size: 'small', options: options, value: item.value || [], onChange: handleChange, renderInput: params => _jsx(TextField, { ...params, variant: 'standard', placeholder: 'Filter...' }), sx: { minWidth: 150, mt: 'auto' } }));
};
//# sourceMappingURL=data-grid-filter.js.map